// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__A3jCo","log":"ModalInventoryLogs_log__wmf1i","date":"ModalInventoryLogs_date__3-ndG","userName":"ModalInventoryLogs_userName__3f_Nk"};